export default __webpack_public_path__ + "static/media/logo_linear.3779ff80.png";